import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from "../../_services/authentication.service";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs'
import * as Moment from 'moment'

import { AstrolyticsService } from "../../_services/astrolytics.service";
import { CacheService } from "../../_services/cache.service";

@Component({
  selector: 'app-dashboard-page',
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.css']
})
export class DashboardPageComponent implements OnInit {

  graphSubscription : Subscription;
  graphStoreSubscription : Subscription;
  favoriteSubscription: Subscription;

  graphData:any;
  storeData: any;

  graphDataSeller: any;
  graphDataStore: any;

  tableData:any;

  loading;
  loadingStore;

  cacheKey;
  cacheKeyStore;

  protected userFavorites = {
    listings: [],
    sellers: []
  }

  constructor(private auth : AuthenticationService, private cs : CacheService,   private router: Router, private astrolyticsService : AstrolyticsService) {
    if (!auth.isAuth()){
      this.router.navigate(['/login']);
    } else{
      this.cacheKey = "favorites-data-"+this.auth.currentUserValue.id;
      this.cacheKeyStore = "favorites-data-stores-"+this.auth.currentUserValue.id;
    }
  }

  ngOnInit() {
    this.loading = true;
    this.loadingStore = true;
    if (this.auth.isAuth()){
      this.graphSubscription = this.astrolyticsService.dashboardGraphObservable.subscribe( message =>{
        if (message) {
          this.saveMessage(message);
          this.cs.saveCache(this.cacheKey,message, this.cs.HOUR);
        }
      });

      if (this.cs.isCacheExpired(this.cacheKey)){
        this.astrolyticsService.getDashboardGraphs(this.auth.currentUserValue.id);

      } else{
        this.saveMessage(this.cs.getCache(this.cacheKey));
      }

      this.graphStoreSubscription = this.astrolyticsService.dashboardGraphStoreObservable.subscribe( message => {
        if (message){
          this.saveStoreMessage(message);
          this.cs.saveCache(this.cacheKeyStore,message, this.cs.HOUR);
        }
      });

      if (this.cs.isCacheExpired(this.cacheKeyStore)){
        this.astrolyticsService.getDashboardStoreGraphs(this.auth.currentUserValue.id);

      } else{
        this.saveStoreMessage(this.cs.getCache(this.cacheKeyStore));
      }

      this.favoriteSubscription = this.astrolyticsService.userFavoritesObservable.subscribe(message => {
        this.userFavorites = message;
      });

     /*  this.astrolyticsService.getDashboardGraphs(this.auth.currentUserValue.id);
      this.astrolyticsService.getDashboardStoreGraphs(this.auth.currentUserValue.id); */
      this.astrolyticsService.getUserFavorites(this.auth.currentUserValue.id);
    }
  }


  saveMessage(message){
    this.processDates(message)
    this.graphData = message;
    this.graphDataSeller = message;
    this.tableData = message.table;
    this.loading = false;
  }

  saveStoreMessage(message){
    //this.processGraphDates(message.sellers_graph)
    this.storeData = message;
    this.graphDataStore = message;
    this.loadingStore = false;
  }
  processDates(data) {
/*     this.processGraphDates(data.sold_graph)
    this.processGraphDates(data.price_usd_graph)
    this.processGraphDates(data.price_uyu_graph)
    this.processGraphDates(data.stock_graph) */
  }

  processGraphDates(graphData) {
    if (graphData){
      graphData.forEach(listing => {
        listing.data.forEach(point => {
          point.x = Moment(point.x, "YYYY/MM/DD");
        });
      });
    }
  }

  deleteFav(meliId) {
      if (this.userFavorites["listings"].includes(meliId)) {
        let index = this.userFavorites["listings"].indexOf(meliId)
        this.userFavorites["listings"].splice(index, 1)
        this.updateFavs()
      }
      let element = $(`tr[data-meli-id="${meliId}"]`)
      element.remove()
      this.deleteFavData(meliId)
  }

  updateFavs() {
    var userId = this.auth.currentUserValue.id
    this.astrolyticsService.updateUserFavorites(this.userFavorites, userId)
    this.cs.clearCache(this.cacheKey);
  }

  deleteFavData(meliId) {
    var userId = this.auth.currentUserValue.id
    this.astrolyticsService.deleteUserFavData(userId, meliId)
  }

}
